module.exports = __webpack_public_path__ + "img/download.cdf51624.svg";